module.exports = __webpack_public_path__ + "img/60d75992564dac5db3bffd31dabec8a4.svg";